"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Range = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _RangeMixin = require("../../mixins/components/RangeMixin");
/**
 * A native ["range" input](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input/range)
 * element, also commonly known as a slider.
 *
 * @related ['Slider']
 * @since 6.11.0
 */
var Range = /*#__PURE__*/(0, _styledComponents.default)( /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
  return /*#__PURE__*/_react.default.createElement("input", (0, _extends2.default)({
    type: "range"
  }, props, {
    ref: ref
  }));
})).withConfig({
  displayName: "Range",
  componentId: "c11n-8-107-0__sc-afacwm-0"
})(["", ""], _RangeMixin.RangeMixin);
exports.Range = Range;
Range.displayName = 'Range';
Range.propTypes = {
  /** https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input/range#max */
  max: _propTypes.default.string.isRequired,
  /** https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input/range#min */
  min: _propTypes.default.string.isRequired,
  /** https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input/range#step */
  step: _propTypes.default.string
};
Range.defaultProps = {
  step: '1'
};

/** @component */